import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const basecamp = defineConnector({
  identifier: "basecamp",
  name: "Basecamp",
  tagLine: "Project management and team communication",
  logo,
  protocol: "http",
  tags: ["productivity", "communication"],
  defaultUrlPattern: () => "https://3\\.basecampapi\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Register an integration",
      items: [
        {
          kind: "markdown",
          content:
            "Register your integration at [37signals Launchpad](https://launchpad.37signals.com/integrations) and copy the client ID and client secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Connect your Basecamp account",
      items: [
        {
          kind: "oauth",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://launchpad.37signals.com/authorization/new",
    tokenEndpoint: () => "https://launchpad.37signals.com/authorization/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://launchpad.37signals.com/authorization.json",
  },
});
